// Папка страницы презентаций для НОВОЙ генерации.
//
// Студийная модель /bots/tools/slides (владелец 2026-08-14): каждая
// презентация живёт в папке, генерация уходит в ОТКРЫТУЮ в рельсе папку —
// «создал — она сразу определилась в папку», как работы в студии /generate
// (зеркало паттерна studioFolderTracker).
//
// Значение живёт в модуле, а не в React-контексте: страница и её виджет —
// разные GenerateProvider (см. presentationPreviewStore), а payload
// собирается в generationRunners вне дерева страницы.

let folderId: string | null = null

/** Страница сообщает открытую папку: при монтировании и каждом переключении. */
export function setSlidesFolder(id: string | null): void {
	folderId = id
}

/** Уход со страницы — генерации снова без папки (бэк подметёт в дефолтную). */
export function clearSlidesFolder(): void {
	folderId = null
}

export function getSlidesFolder(): string | null {
	return folderId
}
